import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import DictionariesApplicationServiceModel, {
  CreateDictionariesApplicationServiceModel,
  UpdateDictionariesApplicationServiceModel,
} from "../../../viewModels/Dictionaries/DictionariesApplicationServiceModel";

import IDictionariesApplicationServiceDto from "../../../dto/Dictionaries/IDictionariesApplicationServiceDto";

import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  applicationServices: Array<DictionariesApplicationServiceModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;

  applicationServiceIdToEdit: number;
  isEditApplicationServiceDrawerOpen: boolean;
  isEditApplicationServiceDrawerLoading: boolean;
} = {
  loading: true,
  loadingData: true,

  applicationServices: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,

  applicationServiceIdToEdit: undefined!,
  isEditApplicationServiceDrawerLoading: false,
  isEditApplicationServiceDrawerOpen: false,
};

const dictionariesApplicationServicesSlice = createSlice({
  name: "dictionariesApplicationServices",
  initialState,
  reducers: {
    loadApplicationServices(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadApplicationServicesSuccess(
      state,
      action: PayloadAction<{ applicationServices: Array<DictionariesApplicationServiceModel>; total: number }>,
    ) {
      const { applicationServices, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.applicationServices = applicationServices;
      state.total = total;
    },
    loadApplicationServicesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    search(state) {
      state.loadingData = true;
    },
    openEditApplicationServiceDrawer(state, action: PayloadAction<number | undefined>) {
      state.applicationServiceIdToEdit = action.payload!;
      state.isEditApplicationServiceDrawerOpen = true;
    },
    closeEditApplicationServiceDrawer(state) {
      if (!state.isEditApplicationServiceDrawerLoading) {
        state.applicationServiceIdToEdit = undefined!;
        state.isEditApplicationServiceDrawerOpen = false;
      }
    },

    createApplicationService(state, _action: PayloadAction<CreateDictionariesApplicationServiceModel>) {
      state.isEditApplicationServiceDrawerLoading = true;
    },
    createApplicationServiceSuccess(state) {
      state.isEditApplicationServiceDrawerLoading = false;
      state.isEditApplicationServiceDrawerOpen = false;
    },
    createApplicationServiceError(state) {
      state.isEditApplicationServiceDrawerLoading = false;
    },

    updateApplicationService(state, _action: PayloadAction<UpdateDictionariesApplicationServiceModel>) {
      state.isEditApplicationServiceDrawerLoading = true;
    },
    updateApplicationServiceSuccess(state, action: PayloadAction<IDictionariesApplicationServiceDto>) {
      const index = state.applicationServices.findIndex((x) => x.id === action.payload.id);
      state.applicationServices[index] = action.payload;
      state.isEditApplicationServiceDrawerLoading = false;
      state.isEditApplicationServiceDrawerOpen = false;
    },
    updateApplicationServiceError(state) {
      state.isEditApplicationServiceDrawerLoading = false;
    },

    deleteApplicationService(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    deleteApplicationServiceSuccess(state) {
      state.loadingData = false;
    },
    deleteApplicationServiceError(state) {
      state.loadingData = false;
    },
  },
});

export default dictionariesApplicationServicesSlice;
